export const TIPOS_INTERVALO_TOPE = [
    { id: 1, description: 'Cantidad dias' },
    { id: 2, description: 'Diario' },
    { id: 3, description: 'Mensual' },
    { id: 4, description: 'Anual' },
]
